import { Checkbox, Form } from "@/components/Form";
import * as z from "zod";
import { Button } from "@/components/Elements";
import {
  useAddEditPermissionMutation,
  useLazyGetPermissionsQuery,
} from "../api/setting";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";

const schema = z.array(
  z.object({
    id: z.coerce.number(),
    name: z.string(),
    showMenu: z.coerce.boolean(),
  })
);

export const Permissions = () => {
  const [addEditPermission] = useAddEditPermissionMutation();
  const [getPermissions] = useLazyGetPermissionsQuery();
  const permissions = useSelector(
    (state: RootState) => state.setting.permissions
  );

  useEffect(() => {
    getPermissions();
  }, []);

  const handleUpdate = async (payload: any) => {
    addEditPermission(payload);
  };

  return (
    <Form<any, typeof schema>
      onSubmit={async (values) => {
        handleUpdate(values);
      }}
      schema={schema}
      options={{ values: permissions }}
    >
      {({ register, handleSubmit }) => (
        <div className="p-[10px]">
          {permissions?.map((item, index) => (
            <Checkbox
              key={item.name}
              label={item.name}
              className="w-6 h-6"
              registration={{
                ...register(`${index}.showMenu`),
              }}
              defaultChecked={item.showMenu}
            />
          ))}
          <Button
            onClick={handleSubmit(handleUpdate, (error) => {
              console.log("error", error);
            })}
          >
            Update
          </Button>
        </div>
      )}
    </Form>
  );
};
